export const BROADCAST_SAMPLE_RATE = 48_000;

function text(bytes, offset, length) {
  return String.fromCharCode(...new Uint8Array(bytes, offset, length));
}

export function inspectBroadcastWav(bytes) {
  const view = new DataView(bytes);
  if (bytes.byteLength < 44 || text(bytes, 0, 4) !== "RIFF" || text(bytes, 8, 4) !== "WAVE") {
    throw new Error("not_broadcast_wav");
  }
  let format = null;
  let dataBytes = 0;
  for (let offset = 12; offset + 8 <= bytes.byteLength;) {
    const id = text(bytes, offset, 4);
    const size = view.getUint32(offset + 4, true);
    const start = offset + 8;
    if (start + size > bytes.byteLength) throw new Error("damaged_wav");
    if (id === "fmt " && size >= 16) {
      format = {
        codec:view.getUint16(start, true),
        channels:view.getUint16(start + 2, true),
        sampleRate:view.getUint32(start + 4, true),
        blockAlign:view.getUint16(start + 12, true),
        bits:view.getUint16(start + 14, true),
      };
    }
    if (id === "data") dataBytes = size;
    offset = start + size + (size % 2);
  }
  if (!format || format.codec !== 1 || format.sampleRate !== BROADCAST_SAMPLE_RATE || format.bits !== 16 || ![1, 2].includes(format.channels) || !dataBytes) {
    throw new Error("not_broadcast_wav");
  }
  const frames = dataBytes / format.blockAlign;
  return { bytes, frames, duration:frames / format.sampleRate, converted:false };
}

export function encodeBroadcastWav(audioBuffer) {
  const frames = audioBuffer.length;
  const channels = 2;
  const blockAlign = channels * 2;
  const dataSize = frames * blockAlign;
  const bytes = new ArrayBuffer(44 + dataSize);
  const view = new DataView(bytes);
  const write = (offset, value) => [...value].forEach((character, index) => view.setUint8(offset + index, character.charCodeAt(0)));
  write(0, "RIFF"); view.setUint32(4, 36 + dataSize, true); write(8, "WAVE");
  write(12, "fmt "); view.setUint32(16, 16, true); view.setUint16(20, 1, true);
  view.setUint16(22, channels, true); view.setUint32(24, BROADCAST_SAMPLE_RATE, true);
  view.setUint32(28, BROADCAST_SAMPLE_RATE * blockAlign, true); view.setUint16(32, blockAlign, true); view.setUint16(34, 16, true);
  write(36, "data"); view.setUint32(40, dataSize, true);
  const left = audioBuffer.getChannelData(0);
  const right = audioBuffer.numberOfChannels > 1 ? audioBuffer.getChannelData(1) : left;
  let offset = 44;
  for (let frame = 0; frame < frames; frame += 1) {
    for (const sample of [left[frame], right[frame]]) {
      const value = Math.max(-1, Math.min(1, sample));
      view.setInt16(offset, value < 0 ? Math.round(value * 32_768) : Math.round(value * 32_767), true);
      offset += 2;
    }
  }
  return { bytes, frames, duration:frames / BROADCAST_SAMPLE_RATE, converted:true };
}

export async function prepareBroadcastAudio(file) {
  const sourceBytes = await file.arrayBuffer();
  try {
    return inspectBroadcastWav(sourceBytes);
  } catch {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass || !window.OfflineAudioContext) throw new Error(`${file.name}: tento prohlížeč neumí zvuk převést.`);
    const context = new AudioContextClass();
    try {
      const decoded = await context.decodeAudioData(sourceBytes.slice(0));
      const frames = Math.max(1, Math.ceil(decoded.duration * BROADCAST_SAMPLE_RATE));
      const renderer = new window.OfflineAudioContext(2, frames, BROADCAST_SAMPLE_RATE);
      const source = renderer.createBufferSource();
      source.buffer = decoded;
      source.connect(renderer.destination);
      source.start(0);
      return encodeBroadcastWav(await renderer.startRendering());
    } catch {
      throw new Error(`${file.name}: formát se v tomto prohlížeči nepodařilo dekódovat.`);
    } finally {
      await context.close().catch(() => {});
    }
  }
}
